import { render } from "./DetailPage.vue?vue&type=template&id=0723f9e4&scoped=true"
import script from "./DetailPage.vue?vue&type=script&lang=js"
export * from "./DetailPage.vue?vue&type=script&lang=js"

import "./DetailPage.vue?vue&type=style&index=0&id=0723f9e4&scoped=true&lang=css"

import exportComponent from "/Users/zhangyi/Documents/code/box/gaoDi/front/scitech-china/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0723f9e4"]])

export default __exports__